(() => {
  'use strict';
  const dock=document.querySelector('[data-two-nu-whatsapp-navigation]');
  if(!dock)return;
  document.documentElement.classList.add('two-nu-account-navigation');
  const native=dock.querySelector('shopify-account');
  let identityTimer=null,identityBusy=false;
  async function refreshIdentity(){
    if(identityBusy||!native)return;
    identityBusy=true;
    try{
      const url=new URL(location.href);url.searchParams.set('section_id',dock.dataset.accountSectionId);url.searchParams.set('_account_check',Date.now());
      const response=await fetch(url,{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)return;
      const html=new DOMParser().parseFromString(await response.text(),'text/html');
      if(html.querySelector('[data-customer-signed-in="true"]')){
        clearInterval(identityTimer);
        const back=new URL(location.href);back.searchParams.set('support_view','account');if(dock.dataset.accountPreviewTheme)back.searchParams.set('preview_theme_id',dock.dataset.accountPreviewTheme);
        location.replace(back.href);
      }
    }catch{}finally{identityBusy=false;}
  }
  native?.addEventListener('open',()=>{
    document.dispatchEvent(new CustomEvent('two-nu:support:close'));
    clearInterval(identityTimer);identityTimer=setInterval(refreshIdentity,2500);
  });
  native?.addEventListener('close',()=>{clearInterval(identityTimer);void refreshIdentity();});
  window.addEventListener('pagehide',()=>clearInterval(identityTimer));
  // Re-read server identity when a signed-in page is restored after logout.
  window.addEventListener('pageshow',event=>{if(event.persisted)location.reload();});
  const trigger=dock.querySelector('[data-two-nu-account-open]');
  function openAccount(event){
    event?.preventDefault();
    document.dispatchEvent(new CustomEvent('two-nu:support:open',{detail:{trigger}}));
    document.dispatchEvent(new CustomEvent('two-nu:account:open'));
  }
  trigger?.addEventListener('click',openAccount);
  document.addEventListener('two-nu:support:state',event=>{
    trigger?.setAttribute('aria-expanded',String(event.detail?.open===true));
  });
  // Existing menu account links now use the same account entry as the dock.
  document.addEventListener('click',event=>{
    const anchor=event.target.closest?.('a[href]');if(!anchor||anchor.closest('shopify-account,.two-nu-account-card'))return;
    const url=new URL(anchor.href,location.href);
    if(url.origin!==location.origin||!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?account\/?$/.test(url.pathname))return;
    if(trigger)openAccount(event);
    else if(native){const button=native.shadowRoot?.querySelector('button');if(button){event.preventDefault();button.click();}}
  });
})();
